import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import FR from './fr.json';
import EN from './en.json';

enum ILanguage {
  en = 'en',
  fr = 'fr',
}

const resources = {
  en: {
    translation: EN,
  },
  fr: {
    translation: FR,
  },
};

// we do not use LanguageDetector to force fr locale
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export { ILanguage, i18n };
